<template>
  <div class="scene-info right_cont">
    <el-breadcrumb
      v-if="!embedInRecycle"
      separator-class="el-icon-arrow-right"
    >
      <el-breadcrumb-item :to="{ path: '/' }">
        {{ $t("breadcrumb.home") }}
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ name: 'control' }">
        {{ $t("breadcrumb.control") }}
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ name: 'control' }">
        {{ $t("breadcrumb.scence") }}
      </el-breadcrumb-item>
      <el-breadcrumb-item>{{ $t("breadcrumb.scenceMsg") }}</el-breadcrumb-item>
    </el-breadcrumb>
    <div
      class="out_bread"
    >
      <div class="scene_main">
        <!-- <img
            src="../../../../assets/img/bg/colors.png"
            alt=""
          > -->
        <div class="scene_main_scroll">
          <BaseInfo
            v-show="parameters.from !== 'feifan'"
            ref="baseInfo"
            :parameters="parameters"
          />
          <TripOption
            v-show="parameters.from !== 'feifan'"
            v-if="option && optionRange"
            ref="TripOption"
            :option="option"
            :option-range="optionRange"
          />
          <TripList
            v-if="checkDeviceList && checkDeviceList.length !== 0"
            ref="TripList"
            :draw-canvas-instance="drawCanvasInstance"
            :list="checkDeviceList"
            :shape-type="parameters.shapeType"
            :canvas-init-data="canvasInitData"
            :version="version"
            :from="parameters.from"
            is-tianmu
            @onSort="onCheckDeviceListSort"
            @onAddLamp="onAddLamp"
            @onTripActive="onTripActive"
            @updateDeviceList="val => checkDeviceList = val"
          />
          <div class="scene_preview_block">
            <LightStripSceneCanvas
              ref="LightStripSceneCanvas"
              :shape-type="parameters.shapeType"
              :from="parameters.from"
              :canvas-init-data="canvasInitData"
              :check-device-list="checkDeviceList"
              :get-first-device-id="getFirstDeviceId"
              @onDeviceActive="onDeviceActive"
              @imgUpdate="onImgUpdate"
              @canvasReady="onCanvasReady"
            />
            <div
              v-show="parameters.from !== 'feifan'"
              class="scene_main_row_modeSelect"
            >
              <div :class="{active: imageMode === 1}" @click="imageMode = 1">
                {{ $t("sceneTemplate.originalImage") }}
              </div>
              <div :class="{active: imageMode === 2}" @click="imageMode = 2">
                {{ $t("sceneTemplate.sdlColor") }}
              </div>
            </div>
          </div>
          <div
            class="scene_btnList"
          >
            <!-- 取消 -->
            <el-button
              v-if="!embedInRecycle"
              plain
              @click="handlerBack"
            >
              {{ $t('findGateway.cancle') }}
            </el-button>
            <!-- <el-button
                class="scene_save"
                plain
                @click="handlerPutFeifanData"
              >
                导入数据包
              </el-button> -->
            <el-upload
              v-if="parameters.from === 'feifan'"
              class="upload-demo"
              action="#"
              :on-change="handleFileChange"
              :auto-upload="false"
              :show-file-list="false"
              accept=".json"
            >
              <el-button
                class="scene_save"
                plain
              >
                {{ $t('projectmsg.exportIn').replace(':', '') }}
              </el-button>
            </el-upload>
            <!-- <el-button
                class="scene_save"
                plain
                @click="readFeifanData"
              >
                导入数据包
              </el-button> -->
            <!-- 导出数据 -->
            <el-button
              v-if="parameters.from === 'feifan'"
              class="scene_save"
              plain
              @click="getFeifanData"
            >
              {{ $t('projectmsg.exportOut').replace(':', '') }}
            </el-button>
            <!-- 保存 -->
            <el-button
              v-if="parameters.from !== 'feifan' && parameters.from !== 'recycle'"
              class="scene_save"
              plain
              :loading="isLoadingSave"
              @click="handlerSaveClick"
            >
              {{ $t('sceneCard.save') }}
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getFillOrderFn,
} from "@/page/control-ts/scene/sceneHandle/indexFns";
import {
  Create as reqSaveScene,
  Edit as reqEditScene,
  FindScene,
  SceneRecoverDetail,
  SaveOrUpdateCustomData,
  GetCustomDataList,
  CreateForControlDevice
} from "@/axios/IScene.js";
import { alerterror, alertsuccess } from "@/assets/js/common.js";
import { mergeSceneRouteOpts } from '@/utils/imageSceneRoute';
import LightStripSceneCanvas from './LightStripSceneCanvas';
import BaseInfo from "../components/BaseInfo.vue";
import TripList from "../components/TripList";
import TripOption from '../components/TripOption';
import { transformPointToCXCY } from '@/components/DesignCanvas/utils/common';
import { LAMP_LAYOUT_SERVICE_MODE } from  "@/components/DrawCanvas/enums/index";
import {
  Finduiability,
  FindActionAbilityWithStatus,
  FindConfigAbility,
} from '@/axios/IDevice.js'
import { getShuangluDeviceInfo } from '@/utils/device';
import { TEMPLATE_1 } from './template/index';
import Feifan from './FeifanMixin';

let getSortOrderValue = () => null;

export default {
  components: {
    BaseInfo,
    TripList,
    LightStripSceneCanvas,
    TripOption
  },
   mixins: [Feifan],
  props: {
    /** 回收站弹窗内嵌查看 */
    embedInRecycle: {
      type: Boolean,
      default: false
    },
    embedSceneNo: {
      type: Number,
      default: undefined
    },
    embedGpNo: {
      type: Number,
      default: undefined
    }
  },
  data() {
    return {
      isAlive: true,
      shapeType: 0,
      // 弹窗中填写的灯带信息 来自上个路由带过来
      // stripDialogInfo: {
      //   row: 0,
      //   col: 0,
      //   directionType: -1, // 横向 1 纵向 2 自定义 3
      //   checkDeviceList: [],
      //   CustomGroups: [],
      //   gpNo: null
      // },
      checkDeviceList: [],
      option: null,
      canvasInitData: null,
      parameters: {},
      designCanvasInstance: null, // 用于纵横能力的组件 获取颜色能力
      drawCanvasInstance: null, // 用于自定义的组件 获取颜色信息
      drawInstance: null,
      bgUrl: '', // 图片上传地址
      isLoadingSave: false,
      version: 0,
      imageMode: 1,
      matrixValueUi: null,
      optionRange: null
    };
  },
  computed: {
    appDocumentWidth() {
      return this.$store.state.appDocumentWidth;
    },
    // effectiveCount() {
    //   let count = 0;
    //   if (this.checkeddata.length > 0) {
    //     this.checkeddata.forEach((n) => {
    //       if (
    //         (n.ActionList && n.ActionList.length > 0) ||
    //         (n.Rules && n.Rules.length > 0)
    //       ) {
    //         count++;
    //       }
    //     });
    //   }
    //   return count;
    // },
  },
  watch: {
    appDocumentWidth(value, oldVal) {
      if (oldVal === value) return;
      getSortOrderValue = getFillOrderFn(value);
    },
  },
  created() {
    this.isAlive = true;

    if (this.embedInRecycle) {
      this.parameters.from = 'recycle';
      this.parameters.SceneNo = this.embedSceneNo;
      this.parameters.GpNo = this.embedGpNo;
      this.requestInfo();
      return;
    }

    const params = mergeSceneRouteOpts(this.$route);

    this.parameters.from = params.from;

    if (params.from === 'feifan') {
      this.doFeiFan();
      return;
    };

    // this.parameters.shapeType = params.shapeType;
    if (params.from === 'edit' || params.from === 'copy' || params.from === 'recycle') {
      // 初始化编辑模式查询场景
      this.requestInfo();
    } else {
      this.option = { light: 255 };
      this.initRouteParams();
    }
  },
  beforeDestroy() {
    this.isAlive = false;

    // v-if 在 beforeDestroy 内更新是异步的，需同步销毁子实例以断开 Watcher → DOM 链
    this.$children.slice().forEach((child) => {
      child.$destroy();
    });

    getSortOrderValue = () => null;

    // Canvas 实例由 LightStripSceneCanvas 负责销毁，此处仅断开引用
    this.drawCanvasInstance = null;

    // 清理其他实例引用
    this.designCanvasInstance = null;
    this.drawInstance = null;

    // 清理所有数据引用
    this.parameters = {};
    this.checkDeviceList = [];
    this.canvasInitData = null;
    this.option = null;
    this.optionRange = null;
    
    this.matrixValueUi = null;
    this.bgUrl = '';
  },
  
  destroyed() {
    // Vue 2 销毁后 _vnode / $el.__vue__ 仍持有整棵 DOM 树
    if (this.$el && this.$el.__vue__) {
      this.$el.__vue__ = null;
    }
    this._vnode = null;
  },
  methods: {
    /**
     * 设置对应设备的色域范围
     * @param {*} device 
     */
    async setFinduiability(device) {
      try {
        const res = await FindActionAbilityWithStatus({
          classSku: device.ClassSku,
          vDeviceId: device.VDeviceId
        });

        if (!this.isAlive) return;

        const uiRes = await Finduiability({
          vDeviceId: device.VDeviceId
        });
        // console.log('setFinduiability', res, uiRes);

        if (!uiRes || !uiRes.Result || !uiRes.Result.UIConfigV2) return;
        
        const actionList = res?.Result && res.Result.reduce((pre, next) => {
          return pre.concat(next.ActionList);
        }, []);
        // const actionValuesList = actionList.reduce((pre, next) => {
        //   return pre.concat(next.Values);
        // }, []);

        const imageScene = uiRes.Result.UIConfigV2.imageScene || {};

        if (imageScene.matrix) {
          const matrixValue = actionList.find(item => item.Code === imageScene.matrix);

          if (matrixValue && matrixValue.UI) {
            this.matrixValueUi = matrixValue.UI;
          };
        };
      } catch (e) {}  
    },

    /** 取第一台未删除且有 ClassSku 的设备，用于拉能力 */
    getValidAbilityDevice(deviceList = []) {
      return (deviceList || []).find(item => !item.IsDel && item.ClassSku != null) || null
    },

    /**
     * 获取亮度min和max
     * @param {*} device 
     */
    async getOptionRange(device) {
      if (!device) return null;

      const { ClassSku, realVDeviceId } = device || {};
      const res = await FindActionAbilityWithStatus({
        classSku: ClassSku,
        vDeviceId: realVDeviceId
      })

      if (!this.isAlive) return null;

      const actionList = res?.Result && res.Result.reduce((pre, next) => {
        return pre.concat(next.ActionList);
      }, []);
      const actionValuesList = (actionList || []).reduce((pre, next) => {
        return pre.concat(next.Values);
      }, []);
  
      const lightAction = actionValuesList.find(item => item.ValueType === 'UIControl_Bright');
      const temperatureAction = actionValuesList.find(item => item.ValueType === 'UIControl_ColorTemperature');
      const duvAction = actionValuesList.find(item => item.ValueType === 'UIControl_ColorTemperature_SDL_DUV');

      return {
        optionRange: {
          light: {
            Max: lightAction ? lightAction.Max : 255,
            Min: lightAction ? lightAction.Min : 0
          },
          temperature: {
            Max: temperatureAction ? temperatureAction.Max : 255,
            Min: temperatureAction ? temperatureAction.Min : 0
          },
          duv: {
            Max: duvAction ? duvAction.Max : 8,
            Min: duvAction ? duvAction.Min : -8
          }
        },
        defaultOption: {
          light: Number(lightAction?.DefaultValue) || 255,
          temperature: Number(temperatureAction?.DefaultValue),
          duv: Number(duvAction?.DefaultValue)
        }
      }
    },

    requestInfo() {
      const routeOpts = mergeSceneRouteOpts(this.$route);
      const sceneNo = this.embedInRecycle
        ? this.embedSceneNo
        : routeOpts.SceneNo;
      const gpNo = this.embedInRecycle
        ? this.embedGpNo
        : routeOpts.GpNo;

      this.parameters.SceneNo = sceneNo;
      this.parameters.GpNo = gpNo;

      let para = {
        sceneNo
      };

      if (this.parameters.from === 'recycle') {
        SceneRecoverDetail(para, this.initInfo);
        return;
      }

      FindScene(para, this.initInfo);
    },

    async initInfo(res) {
      if (!this.isAlive) return;
      if (
        res.StatusCode == this.$store.state.rightStatusCode &&
        res.Result
      ) {
        this.parameters = {
          ...this.parameters,
          ConfigStatus: res.Result.ConfigStatus
        };
  
        let totalNum = 0;
        this.parameters.ConfigStatus = res.Result.ConfigStatus;

        const Mark4Res = await GetCustomDataList({
          projectCode: this.$store.state.projectcode,
          type: 'MatrixScene',
          identifier: this.parameters.SceneNo
        });

        const Mark4 = ((Mark4Res?.Result || [])[0] || {}).Content || res.Result.Mark4 || '{}';
        let MarkRes = {};

        try {
          MarkRes = JSON.parse(Mark4);
          
        } catch (e) {

        }

        const { directionType, initData, appData = {} } = MarkRes;

        if (!this.isAlive) return;

        const deviceList = await this.handlerDeviceListWithShuanglu(res.Result.DeviceList || [], true, appData.position || []);

        if (!this.isAlive) return;
        const abilityDevice = this.getValidAbilityDevice(deviceList);
        if (abilityDevice) {
          this.setFinduiability(abilityDevice);
          const ActionList = abilityDevice.ActionList || {};
          const Values = (ActionList[0] || {}).Values || [];
          const totalNumModal = Values.find(item => item.KeyId === 3);

          const { optionRange } = await this.getOptionRange(abilityDevice) || {};

          if (!this.isAlive) return;
          this.optionRange = optionRange;
    
          if (totalNumModal) totalNum = totalNumModal.Value;
        };

        // const { Mark4 } = res.Result;

        if (!!MarkRes) {
            const option = MarkRes.option || { light: 255 };
            this.bgUrl = initData.bg.url;
            this.version = MarkRes.version || 0;
            this.imageMode = MarkRes.option?.imageMode === undefined ? 1 : MarkRes.option?.imageMode
            this.parameters.deviceText = MarkRes.option?.deviceText || '';
            this.parameters.shapeType = MarkRes.shapType;

            // 已经删除了的设备 线圈不要了
            const delDeviceIds = deviceList.filter(item => !!item.IsDel).map(item => item.VDeviceId);
            const modeData = initData.modeData;

            for (let k in modeData) {
              if (delDeviceIds.includes(k)) delete modeData[k];

              const lampData = modeData[k];
              // 老版本数据 原本会忽略短边 现在不忽略 所以直接按补0
              if (
                this.version === 0 && 
                lampData.l && 
                lampData.l.m === LAMP_LAYOUT_SERVICE_MODE.SIMGLE_LINE_AVERAGE && 
                lampData.l.l &&
                lampData.l.l.length > 1
              ) {
                lampData.l.l = lampData.l.l.join(',0,').split(',');
              }
            }

            // console.log('modeData 999', modeData);
            
            // console.log('initData', this.initData);
            
            this.canvasInitData = {
              ...initData,
              modeData
            };
            
            this.option = option;
            // this.stripDialogInfo.directionType = directionType;            
        }

        this.$refs.baseInfo && this.$refs.baseInfo.setFormData({
          SecneName: res.Result.SecneName,
          SceneType: res.Result.SceneType
        });

        // 删除的设备放最下面
        this.checkDeviceList = deviceList
          .filter(item => !item.IsDel)
          .concat(
            deviceList.filter(item => !!item.IsDel)
          );
        // this.stripDialogInfo.CustomGroups = res.Result.CustomGroups;
        // this.stripDialogInfo.gpNo = res.Result.GpNo;
      }
    },

    setImgByDeviceList(deviceList) {
    },
  
    // 初始化路由参数
    async initRouteParams() {
      const params = mergeSceneRouteOpts(this.$route);

      if (!params || !params.shapeType) {
        this.$router.push({
          name: 'control'
        });
      }
      
      this.parameters.shapeType = params.shapeType;
      this.parameters.GpNo = params.GpNo;
      this.parameters.CustomGroups = params.CustomGroups;
      
      this.parameters.deviceText = params.deviceText;

      const checkDeviceList = await this.handlerDeviceListWithShuanglu(params.checkDeviceList || []);

      if (!this.isAlive) return;
      if (checkDeviceList.length === 0) return;
    
      this.checkDeviceList = checkDeviceList;

      const { optionRange, defaultOption } = await this.getOptionRange(
        this.getValidAbilityDevice(checkDeviceList)
      ) || {};

      if (!this.isAlive) return;
      this.optionRange = optionRange;

      if (this.parameters.shapeType === 1) {
        const { directionType, initData } = TEMPLATE_1;
        const option = TEMPLATE_1.option || { light: 255 };
        this.bgUrl = initData.bg.url;
        // 已经删除了的设备 线圈不要了
        // const delDeviceIds = this.checkDeviceList.filter(item => !!item.IsDel).map(item => item.VDeviceId);
        const modeData = initData.modeData;
        const copyModeData = {};

        this.checkDeviceList.forEach((item, index) => {
          const { VDeviceId } = item;

          copyModeData[VDeviceId] = initData.modeData[index];
        });

        this.setFinduiability(this.checkDeviceList[0]);
        console.log('initData', initData);

        this.canvasInitData = {
          ...initData,
          modeData: copyModeData
        };
        
        this.option = defaultOption;
      } else {
        this.option = defaultOption;
      }
      // `{"directionType":3,"initData":{"bg":{"url":"https://appresource.opple.com/media/business/102/20231213094651_6.jpg","width":794,"height":456},"modeType":"TEMPLATE","modeData":{"1000980":{"p":{"dl":[{"s":"C","f":"P","r":{"x":41,"y":75}},{"s":"C","f":"P","r":{"x":388,"y":75}},{"s":"C","f":"P","r":{"x":315,"y":168}},{"s":"C","f":"P","r":{"x":173,"y":168}},{"s":"C","f":"P","r":{"x":173,"y":224}},{"s":"C","f":"P","r":{"x":378,"y":224}},{"s":"C","f":"P","r":{"x":370,"y":273}},{"s":"C","f":"P","r":{"x":236,"y":273}},{"s":"C","f":"P","r":{"x":216,"y":337}},{"s":"C","f":"P","r":{"x":472,"y":337}}],"m":"L"},"l":{"m":"SA","c":23,"l":[10,5,4,3,1]}}}},"option":{"light":255}}`
     

      // shapeType: this.shapeType,
      //     checkDeviceList,
      //     from: 'create'
      // if (
      //   (!params ||
      //   !params.row ||
      //   !params.col) &&
      //   params.directionType !== 3
      // ) {
      //   this.$router.push({
      //     name: 'control'
      //   });
      // };

      // this.stripDialogInfo = {
      //   ...params,
      // };

      // const controlAche = getLocalStoragItem("control") || '{}';

      // try {
      //   const ache = JSON.parse(controlAche);

      //   this.parameters = {
      //     ...this.parameters,
      //     ...ache
      //   };
      // } catch (e) {
      //   console.log('e', e);
      // }

    },
    // 编辑模式查询场景
    async initFindScene() {
      const controlAche = getLocalStoragItem("control") || '{}';

      try {
        const params = JSON.parse(controlAche);

        this.parameters = {
          ...this.parameters,
          ...params
        };

        if (params.SceneNo) {
          const res = await FindScene({
            sceneNo: params.SceneNo
          });

          this.handlerFindScene(res);
        }
      } catch (e) {
        console.log('e', e);
      }
    },

    async handlerDeviceListWithShuanglu(list, isNeedIncorporate = false, positions) {
      let checkDeviceList = list;
    
      if (isNeedIncorporate) {
        let AllDevice = {};


        checkDeviceList.forEach(device => {
          if (AllDevice[device.VDeviceId]) {
            AllDevice[device.VDeviceId].push(device);
          } else {
            AllDevice[device.VDeviceId] = [device];
          };
        });

        checkDeviceList = Object.values(AllDevice).map(list => list[0])
      }
       
      const resList = await Promise.all(
        checkDeviceList.map(device => FindConfigAbility({
          vDeviceId: device.VDeviceId
        }))
      );

      const returnList = [];


      checkDeviceList.forEach((device, index) => {
        const { 
          isShuanglu,
          childDeviceCount,
          singleLampCounts
        } = getShuangluDeviceInfo(resList[index].Result?.GpList[0].GpDetails, device);

        let deviceInfo = []

        if (positions) {
          deviceInfo = positions.filter(info => info.vDeviceId === device.VDeviceId);
        }

        if (isShuanglu) {
          const shuangluList  = new Array(childDeviceCount).fill('').map((item, index) => {
            let shuangluLampCount = singleLampCounts[index];
          
            // if (isNeedIncorporate) {
            //   const count = Number((((device.ActionList || [])[index]?.Values || []).find(item => item.KeyId === 3) || {}).Value);
              
            //   if (Number.isInteger(count)) shuangluLampCount = count || 0;
            // }

            return {
              ...device,
              realVDeviceId: device.VDeviceId,
              VDeviceId: `${device.VDeviceId}-${index}`,
              deviceNameTag: deviceInfo[index] ? deviceInfo[index].deviceNameTag : `${this.$t('projectmsg.channel')}${index + 1}`,
              shuangluIndex: index,
              isShuanglu: true,
              shuangluLampCount
            }
          });
  
          returnList.push(...shuangluList)
        } else {
          returnList.push({
            ...device,
            realVDeviceId: device.VDeviceId,
            isShuanglu: false,
          })
        }
      });
      console.log('resList', returnList);
      return returnList;
    },

    // 查询场景回调
    handlerFindScene(res) {
      if (
        res.StatusCode !== this.$store.state.rightStatusCode ||
        !res.Result
      ) {
        return
      };

      this.parameters.GpNo = res.Result.GpNo;
      this.parameters.ConfigStatus = res.Result.ConfigStatus;
      this.parameters.ParentAreaNames = res.Result.ParentAreaNames;
      // this.scenlist = rs.Result;
      // this.nameValue = this.scenlist.SecneName;
      // this.selectvalue = this.scenlist.SceneType;

      // this.groupSiftValue = "";
      // this.groupSiftOptions = [];
      // if (rs.Result.CustomGroups != null) {
      //   this.groupSiftOptions = rs.Result.CustomGroups;
      // }

      // this.skuSiftValue = "";
      // this.skuSiftOptions = [];
      // this.addcheckdata(this.scenlist.DeviceList);
    },
  
    // 上移 下移
    onCheckDeviceListSort(newList) {
      this.checkDeviceList = newList;
      this.$forceUpdate();
    },

    // 图片上传
    onImgUpdate({ bgUrl, designCanvasInstance, drawCanvasInstance, title }) {
      this.bgUrl = bgUrl;

      if (designCanvasInstance) {
        this.designCanvasInstance = designCanvasInstance
      }
      
      if (drawCanvasInstance) {
        this.drawCanvasInstance = drawCanvasInstance
      }

      const baseInfo = this.$refs.baseInfo.getFormData();
      
      if (!!title && !baseInfo.nameValue) {
        this.$refs.baseInfo && this.$refs.baseInfo.setFormData({
          SecneName: title,
        });
      }
    },

    // canvas组件就位
    onCanvasReady(drawCanvasInstance) {
      this.drawCanvasInstance = drawCanvasInstance;
    },

    onCanvasImgUpdate(drawInstance) {
      this.drawInstance = drawInstance;
      this.$refs.TripList.resetValues();
    },

    onDeviceActive(VDeviceId) {
      this.$refs.TripList && this.$refs.TripList.setActiveKey(VDeviceId);
    },

    handlerSaveClick() {
      if (this.parameters.from === 'edit') {
        this.reqEdit();
      } else {
        this.reqSave();
      }
    },
    
    // 取消按钮
    handlerBack() {
      if (this.parameters.from === 'feifan') {
        this.$router.push({
          path: '/install'
        });

        return;
      }

      this.$router.push({
        path: '/control'
      })
    },

    // 校验上传保存或者编辑
    verifyCanSave(isVerifyName = true) {
      const baseInfo = this.$refs.baseInfo.getFormData();
      const { checkDeviceList } = this;

      if (!baseInfo.nameValue && isVerifyName) {
        return {
          status: false,
          message: this.$t('scene.plhode1'),
        }
      };

      if (!this.getValidAbilityDevice(checkDeviceList)) {
        return {
          status: false,
          message: this.$t('sceneCard.noAvailableDevice'),
        }
      }

        const lampCountInput = this.$refs.TripList.values;
        let isLampCountCanSubmit = true;

        if (!this.drawCanvasInstance) {
          return {
            status: false,
            message: this.$t('visual.please') + this.$t('visual.uploadImg')
          }
        }

        const canvasData = this.drawCanvasInstance.getColors();

        console.log('canvasData', canvasData);
        let allLength = 0;
        let isShuangluNoData = null;

        Object.entries(canvasData).forEach(([VDeviceId, item]) => {
          allLength += item.length;

          const device = checkDeviceList.find(device => device.VDeviceId === VDeviceId);
          
          if (device && device.isShuanglu && item.length !== device.shuangluLampCount) {
            isShuangluNoData = {
              message: device.DeviceName + '【' + device.deviceNameTag + '】,' +
              this.$t('tianmu.shuangluPoint').replace('{{num}}', device.shuangluLampCount)
            }
          };
        })
        
        if (allLength === 0) {
          return {
            status: false,
            message: this.$t('sceneTemplate.needPath')// '当前矩形场景下请先绘制路径再保存！'
          }
        }

        if (isShuangluNoData) {
          return {
            status: false,
            message: isShuangluNoData.message
          }
        }
    
        for (let i = 0; i < checkDeviceList.length; i++) {
          const { VDeviceId, IsDel, isShuanglu } = checkDeviceList[i];

          // 删除设备不校验
          if (!!IsDel || isShuanglu) continue;

          const lampCountStr = `${lampCountInput[VDeviceId]}`;

          if (lampCountStr.includes(',')) {
            const lampCount = lampCountStr.split(',').map(item => Number(item) || 0).reduce((a, b) => a + b);

            if (Number.isNaN(lampCount) || lampCount > 500) {
              isLampCountCanSubmit = false;
              break;
            }
          } else if (
              Number.isNaN(Number(lampCountStr)) ||
              Number(lampCountStr) === 0 || 
              Number(lampCountStr) > 500
          ) {
            isLampCountCanSubmit = false;
            break;
          }
        }

        if (!isLampCountCanSubmit) {
          return {
            status: false,
            message: this.$t('sceneCard.lightTripInputLampCount') + '1-500'
          }
        }
   

      return {
        status: true
      }
    },

    // 点击保存
    async reqSave() {
      const baseInfo = this.$refs.baseInfo.getFormData();
      const { checkDeviceList } = this;
      const { GpNo, CustomGroups } = this.parameters;
      const isCanSubmit = this.verifyCanSave();

      if (!isCanSubmit.status) {
        this.$message({
          type: 'warning',
          message: isCanSubmit.message
        });

        return;
      }

      try {
        this.isLoadingSave = true;

        const DeviceList = await this.handlerCheckDeviceList(checkDeviceList);
        const Mark4 = this.getMark4();

        const reqParams = {
          GpNo,
          SecneName: baseInfo.nameValue,
          SceneType: baseInfo.selectvalue,
          DeviceList,
          CustomGroups,
          TransportType: 'MatrixScene',
          Mark4: '',
          ShowEntry: 4,
        }

        const res = await reqSaveScene(reqParams);
        // const res = await CreateForControlDevice(reqParams);

        await SaveOrUpdateCustomData([{
          ProjectCode: this.$store.state.projectcode,
          Type: 'MatrixScene',
          Identifier: res.Result,
          Content: Mark4
        }]);

        this.functionDoNotice(res);
      } catch (e) {
        console.log('错误', e);
      } finally {
        this.isLoadingSave = false;
      }
    },

    // 点击保存且编辑
    async reqEdit() {
      const baseInfo = this.$refs.baseInfo.getFormData();
      const { checkDeviceList } = this;
      const { GpNo, CustomGroups, SceneNo } = this.parameters;
      const DeviceList = await this.handlerCheckDeviceList(checkDeviceList);
      const Mark4 = this.getMark4();
      const isCanSubmit = this.verifyCanSave();

      if (!isCanSubmit.status) {
        this.$message({
          type: 'warning',
          message: isCanSubmit.message
        });

        return;
      }
     
      try {
        this.isLoadingSave = true;

        const reqParams = {
          GpNo,
          SecneName: baseInfo.nameValue,
          SceneType: baseInfo.selectvalue,
          DeviceList,
          CustomGroups,
          TransportType: 'MatrixScene',
          SceneNo: SceneNo,
          Mark4: '',
          ShowEntry: 4,
        }
        // console.log('reqParams', reqParams);
        // return;
        const res = await reqEditScene(reqParams);

        await SaveOrUpdateCustomData([{
          ProjectCode: this.$store.state.projectcode,
          Type: 'MatrixScene',
          Identifier: res.Result,
          Content: Mark4
        }]);

        this.functionDoNotice(res);
      } catch (e) {
        console.log('错误', e);
        
      } finally {
        this.isLoadingSave = false;
      }
    },

    /* 提交数据 接口返回处理
     * rs 接口返回数据包
     */
     functionDoNotice(rs) {
      if (rs.StatusCode === this.$store.state.rightStatusCode) {
        alertsuccess(this, rs.StatusCode);

        this.$router.push({
          path: '/control'
        })
        // if (rs.Result) {
        //   // this.removecurrent.push({ sceneNo: rs.Result });
        //   // this.courseDialog = true;
        // } else {
        //   this.gopage();
        // }
      } else {
        alerterror(this, rs.StatusCode);
      }
    },

    onAddLamp(deviceId, lampCount, lampInfoList) { 
      this.$refs.LightStripSceneCanvas && this.$refs.LightStripSceneCanvas.addLamp(deviceId, lampCount, lampInfoList)
    },

    onTripActive(deviceId) {
      this.$refs.LightStripSceneCanvas && this.$refs.LightStripSceneCanvas.setCurLineLayerIndex(deviceId);
    },

    getFirstDeviceId() {
      const checkDeviceList = this.checkDeviceList;

      return (checkDeviceList[0] || {}).VDeviceId;
    },

    async getIsNew(VDeviceId) {
      const res = await Finduiability({ vDeviceId: VDeviceId });

      if (res?.Result?.UIConfigV2?.TianMuVersion === 2) {
        return true;
      }

      return false;
    },

    // 处理选择的设备
    async handlerCheckDeviceList(checkDeviceList) {
      const VDeviceId = checkDeviceList[0].VDeviceId.split('-')[0];
      const isNew = await this.getIsNew(VDeviceId);
      // const { row, col, directionType } = this;  // 1 横向 2 纵向
      // const isCustom = this.directionType === 3;
    
      const newCheckDeviceList = [];

      if (this.drawCanvasInstance === null) return;

      const option = this.$refs.TripOption.getValue();
      const canvasData = this.drawCanvasInstance.getColors();
      // 双路控制器 同样的vdeviceid
      let shuangluAche = {};

      checkDeviceList.filter(item => !item.IsDel).forEach((item, index) => {
        let totalNum = 0;
        let lightCxCyStr = '';
        const isShuanglu = item.isShuanglu;
        const VDeviceId = item.isShuanglu ? item.realVDeviceId : item.VDeviceId;
  
        // 自定义
        const deviceRgbData = canvasData[item.VDeviceId];

        if (Array.isArray(deviceRgbData)) {
          deviceRgbData.forEach(lampData => {              
            const rgba = lampData.rgba || '';
            const rgbaList = rgba.split(',') || [];
            // const CxCy = DesignCanvas.transRgbToCxCy(
            //   Number(rgbaList[0]), 
            //   Number(rgbaList[1]), 
            //   Number(rgbaList[2])
            // );

            const CxCy = transformPointToCXCY({
              color: `${ Number(rgbaList[0])},${Number(rgbaList[1])},${Number(rgbaList[2])},255`,
              light: option.light,
              mode: this.imageMode === 1 ? 'V1' : 'V2'
            }, this.matrixValueUi);

            lightCxCyStr += CxCy; // `${light}${CxCy}`;
          })

          totalNum = deviceRgbData.length;
        } else {
          totalNum = 0;
        }

        // if (isShuanglu) {
        //   if (shuangluAche[VDeviceId]) {
        //     totalNum = shuangluAche[VDeviceId].totalNum + totalNum;
        //     lightCxCyStr = shuangluAche[VDeviceId].lightCxCyStr + lightCxCyStr
        //   }
    
        //   shuangluAche[VDeviceId] = {
        //     totalNum,
        //     lightCxCyStr
        //   }
        // }
      
        const curValue = [{
          KeyId: 0, // Channel
          Value: isShuanglu ? item.shuangluIndex : 0,
        }, {
          KeyId: 1, // Mode
          Value: 2,
        }, {
          KeyId: 2, // StartAddr
          Value: 0,
        }, {
          KeyId: 3, // TotalNum
          Value: totalNum
        }, {
          KeyId: 4,
          Value: lightCxCyStr
        }];

        if(isNew){
          curValue.push({
            KeyId: 5,
            Value: option.light
          })
        }
        // }

        // getLight
        const newActionList = {
          MsgType:  "0x13010000",
          // Channel: 0,
          // Mode: 2,
          // StartAddr: 1,
          // TotalNum: directionType === 1 ? Number(row) : Number(col),
          Values: curValue, // [{KeyId: 1, Value: 1}], // curValue
        }

        newCheckDeviceList.push({
          AreaName: item.AreaName,
          ChannelId: item.ChildId,
          DeviceName: item.DeviceName,
          VDeviceId,
          Mac: item.Mac,
          ActionList: [ newActionList ] // item.ActionList.concat([ newActionList ])
        });
    });

      shuangluAche = {};
      const newCheckDeviceListFilterShuanglu = [];

      // 双路控制器会被推多次 只取最后一次的数据
      for (let i = 0; i < newCheckDeviceList.length; i++) {
        const item = newCheckDeviceList[i];

        if (shuangluAche[item.VDeviceId]) {
          const firstItem = newCheckDeviceListFilterShuanglu.find(device => device.VDeviceId === item.VDeviceId);

          firstItem.ActionList = firstItem.ActionList.concat(item.ActionList)

          continue;
        }

        newCheckDeviceListFilterShuanglu.push(item);
        shuangluAche[item.VDeviceId] = true;
      }

      console.log('newCheckDeviceList', checkDeviceList);
      console.log('newCheckDeviceList', newCheckDeviceList);
      console.log('newCheckDeviceList ==============================');
      
      return newCheckDeviceListFilterShuanglu;
    },

    getMark4() {
      const baseOption = this.$refs.TripOption.getValue();

      if (!this.drawCanvasInstance) return;

      const canvasData = this.drawCanvasInstance.getColors();
      const { checkDeviceList } = this;
      const position = [];

      checkDeviceList.filter(item => !item.IsDel).forEach((item, index) => {
        const list = canvasData[item.VDeviceId] || [];
        //         let posData = [];

        // list.forEach(item => {
        //   posData.push({
        //     x: item.position.pX,
        //     y: item.position.pY,
        //     shadow: item.shadow,
        //     switch: item.switch
        //   });
        // });

        // return {
        //   id: index,
        //   posData,
        //   deviceScale: this.template.scale,
        //   deviceIsGroup: this.template.isGroup,
        //   shape: this.template.shape,
        // }
        // 
        // `${Math.floor(item.x)},${Math.floor(item.y)},0,1`).join(' ')
        const isShuanglu = !!item.isShuanglu;

        position.push({
          id: index,
          posData: list.map(item => ({
            x: item.x,
            y: item.y,
            shadow: false,
            switch: false
          })),
          deviceIsGroup: false,
          deviceScale: -1,
          shape: -1,
          isShuanglu,
          deviceNameTag: item.deviceNameTag,
          vDeviceId: isShuanglu ? item.realVDeviceId : item.VDeviceId
        });
      });
  
      const Mark4 = {
        shapType: this.parameters.shapeType,
        directionType: 3,
        initData: null,
        option: {
          ...baseOption,
          modeType: 1,
          row: 1, 
          col: 1, 
          scale: 1, 
          left: 0, 
          top: 0,
          isShadowOpen: 1,
          imageMode: this.imageMode,
          deviceText: this.parameters.deviceText
          // MarkRes.option?.imageMode
        },
        appData: {
          position,
          bg: this.bgUrl,
          width: this.drawCanvasInstance.data.shapes.bg.canvasWidth, 
          height: this.drawCanvasInstance.data.shapes.bg.canvasHeight, 
        },
        // isShuanglu,
        version: 1
      };

      if (this.drawCanvasInstance) {
        Mark4.initData = this.drawCanvasInstance.getSaveData() || {};

        Mark4.initData.bg.url = this.bgUrl;
      };

      return JSON.stringify(Mark4);
    }
  },
};
</script>

<style lang="scss" scoped>
.scene_main {
  display: flex;
  position: absolute;
  padding: 0 16px;
  box-sizing: border-box;
  width: 100%;
  height: 92%;
  background: #fefefe;

  &_scroll {
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  .scene_preview_block {
    width: 100%;
  }

  &_row_modeSelect {
      display: flex;
      justify-content: center;
      margin-top: 18px;

      &>div {
        padding: 6px 12px;
        border: 1px solid #eee;
        border-radius: 3px;
        margin-right: 10px;
        cursor: pointer;

        &.active {
          background: #002a91;
          color: #fff;
        }
      }
    }

  ::v-deep .scene_title {
    display: flex;
    margin-bottom: 24px;
  }

  ::v-deep .scene_container {
    padding: 20px 45px;
    border: solid 1px #e0e3e6;
  }

  .scene_btnList {
    display: flex;
    justify-content: flex-end;
    margin-top: 48px;

    &>div {
      margin-left: 10px;
    }

    &>button {
      margin-left: 10px;
    }
  }

  .scene_save {
    background-color: #002a91 !important;
    color: #fff !important;

    &:hover {
      background-color: #002a91 !important;
      color: #fff !important;
    }
  }
}
</style>
